import { render, staticRenderFns } from "./ChangeOfStatus.vue?vue&type=template&id=c07c0cde&scoped=true"
import script from "./ChangeOfStatus.vue?vue&type=script&lang=js"
export * from "./ChangeOfStatus.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfStatus.vue?vue&type=style&index=0&id=c07c0cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07c0cde",
  null
  
)

export default component.exports